var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, Tooltip, Typography, TableHead, TableRow, TableCell } from '@mui/material';
import React from 'react';
export var DefaultTableHeader = function (_a) {
    var checkTodos = _a.checkTodos, handleSelectAllChange = _a.handleSelectAllChange, selecionados = _a.selecionados, total = _a.total;
    return (_jsx(TableHead, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: 2, style: { padding: 0 } }, { children: _jsxs(Box, __assign({ display: "flex", alignItems: "center" }, { children: [_jsx(Tooltip, __assign({ title: "Selecionar todos" }, { children: _jsx(Checkbox, { onChange: handleSelectAllChange, checked: checkTodos || false, id: "checkTodos", inputProps: { 'aria-label': 'Selecionar todos' } }) })), _jsxs(Typography, __assign({ variant: "h6" }, { children: [_jsx("b", { children: "Selecionar todos |" }), " ", selecionados, " de ", total, " selecionado(s)"] }))] })) })) }) }));
};
